<template>
  <div
    class="popover"
    tabindex="0"
    @blur="close"
  >
    <slot
      name="trigger"
      :onClick="open"
    />
    <div
      ref="popoverContent"
      :style="{position: 'fixed', top: `${top}px`, left: `${left}px`}"
      :class="{show: isOpen}"
      class="popoverContent"
    >
      <v-icon
        id="close"
        class="closePopover"
        @click="close"
      >
        mdi-close
      </v-icon>
      <slot
        name="content"
        :isClosed="!isOpen"
        :close="close"
      />
    </div>
  </div>
</template>

<script>
export default {
    name: 'Popover',
    props: {
        top: {
            type: String,
            default: '0',
        },
        left: {
            type: String,
            default: '0',
        },
        emptyTrigger: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isOpen: false,
        };
    },
    methods: {
        open() {
            this.isOpen = true;
        },
        close(event) {
            const { relatedTarget } = event || { relatedTarget: null };
            if (!relatedTarget || relatedTarget?.id === 'close') {
                this.isOpen = false;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import './PopoverStyle.scss';
</style>
